export enum OffcanvasDismissReasons {
  BACKDROP_CLICK,
  ESC
}
